import React from 'react';
import styled from 'styled-components/macro';

const TermsOfUseContainer = styled.div``;

export default function TermsOfUse(): JSX.Element {
  return (
    <TermsOfUseContainer>
      <p>
        <strong>iWarranty Terms of Use</strong>
        <strong>
          <br />
        </strong>
        <span>Welcome to iWarranty!</span>
        <span>
          <br />
        </span>
        <span>
          <br />
        </span>
        <span>
          These terms and conditions of use (Terms) govern your use of
          iWarranty and provide information about our service
          (iWarranty Service) which we outline in more detail below.
          When you create an account or otherwise use iWarranty, you
          agree that there is an agreement between you and iWarranty
          Ltd on these Terms and that you will abide by them.
        </span>
      </p>
      <p>
        <strong>Our Service</strong>
        <strong>
          <br />
        </strong>
        <span>
          We agree to provide you with the iWarranty app which
          includes all of the different functionality, features,
          applications, technologies and software that we provide to
          advance our vision and help you better access and manage
          your warranties.
        </span>
      </p>
      <p>
        <span>The iWarranty Service seeks to enable&nbsp;</span>
        <span>
          consumers to utilise different capabilities as they are
          developed, including to capture receipts, scan barcodes and
          register their products, see a summary of key warranty terms
          and make a claim.
        </span>
      </p>
      <p>
        <span>
          In order to facilitate this service, this may involve us
          storing and transferring data across our systems or those of
          our service providers such as manufacturers, insurers or
          retailers around the world, including outside of your
          country of residence. This infrastructure may be owned or
          operated by us or our third party service providers.
        </span>
      </p>
      <p>
        <span>
          To support this we develop and use tools to help combat
          harmful or deceptive conduct and other violations of our
          Terms and policies using your information to try to keep
          iWarranty secure. We also may share information about misuse
          or harmful content with law enforcement authorities. You can
          learn more about this in our Privacy Policy.
        </span>
      </p>
      <p>
        <span>
          We may also connect you with brands, products, and services
          where you want this and in ways you care about by using
          iWarranty user data, as well as from third-party partners,
          to show you ads, offers, and other sponsored content that we
          believe will be meaningful to you in accordance with your
          instructions.
        </span>
      </p>
      <p>
        <span>
          Our Privacy Policy which sets out in more detail how we
          collect and use your information in a way that seeks to
          retain your privacy and that of your content. However, we
          only collect information from you that relates to the
          information you provide as a part of your using the app in
          order to provide you with the iWarranty service and only
          share that information with third parties in relation to the
          provision of additional goods and/or services to the extent
          you select those options. For example, if you are providing
          information about an extended warranty or insurance to cover
          your product, or register your warranty with a manufacturer
          or a retailer, we may pass on your data to a relevant
          provider to enable you to receive an offering in relation to
          that item.
        </span>
      </p>
      <p>
        <strong>Your Commitments</strong>
      </p>
      <p>
        <strong>
          <br />
        </strong>
        <span>
          In return for our providing you with the iWarranty Service
          while using the service, you agree to the following
          commitments in order to make
        </span>
        <span>&nbsp;</span>
        <span>
          iWarranty as open, inclusive, safe and secure as possible
          while retaining its character of privacy, and otherwise
          being used in accordance with the law:
        </span>
        <span />
      </p>
      <p />
      <ul>
        <li>
          <span>You are at least 13 years old.</span>
          <span>
            <p />
          </span>
        </li>
        <li>
          <span>
            You must not be prohibited from receiving any aspect of
            our Service under applicable laws.
          </span>
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          <span>
            We must not have previously disabled your account for
            violation of law or any of our policies or laws.
          </span>
          <span>
            <p />
          </span>
        </li>
        <li>
          <span>
            You must not be use iWarranty in a harmful manner
            including impersonating others or providing deliberately
            misleading information. While you do not have to disclose
            your identity you must otherwise provide us with accurate
            and up to date information (including registration
            information) and not impersonate someone or create or
            access an account for someone else unless you have their
            express permission.
          </span>
          <span>
            <p />
          </span>
        </li>
        <li>
          <span>
            You must not do anything unlawful, misleading, or
            fraudulent or for an illegal or unauthorized purpose.
          </span>
          <span>
            <p />
          </span>
        </li>
        <li>
          <span>
            You must not violate (or help or encourage others to
            violate) these Terms or our policies and will report any
            such conduct or content to us of which you are aware.
          </span>
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          <span>
            You will not do anything to interfere with or impair the
            intended operation of the iWarranty Service.
          </span>
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          <span>
            You will not collect information or content you access
            through the iWarranty Service including by content
            provided by other people with whom you communicate in
            unauthorised ways or otherwise without consent.
          </span>
          <span>
            <p />
          </span>
        </li>
        <li>
          <span>
            You will not post or otherwise announce or communicate
            private or confidential information or do anything that
            violates someone else’s rights, including intellectual
            property.
          </span>
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          <span>
            We can remove any content or information you share on the
            iWarranty Service if we believe that it violates these
            Terms, our policies, or we are required to do so by law.
            We can refuse to provide or stop providing all or part of
            the iWarranty Service to you (including terminating or
            disabling your account) immediately if you: clearly,
            seriously or repeatedly violate these Terms, if you
            repeatedly infringe other people’s intellectual property
            rights, or where we are required to do so by law. If we
            take action to remove your content for violating our
            Community Guidelines or disable or terminate your account,
            we will notify you where appropriate. If you believe your
            account has been terminated in error, or you want to
            disable or permanently delete your account, consult our
            Help Center.
          </span>
        </li>
        <li>
          <span>
            The content you delete may persist for a limited period of
            time in backup copies and will still be visible where
            others have shared it. This paragraph and the section
            below called “Our Agreement and What Happens if We
            Disagree,” will still apply even after your account is
            terminated or deleted.
          </span>
          <span>
            <p />
          </span>
        </li>
        <li>
          <span>
            You must not attempt to transfer, buy or sell any aspect
            of your account (including your email) or solicit,
            collect, or use the login credentials or badges of other
            users.
          </span>
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Your permissions</strong>
      </p>
      <p>
        <span>
          As part of our Terms, you also give us permissions that we
          need to provide the Service including:
        </span>
      </p>
      <ul>
        <li>
          <span>
            A licence to use your content. We do not claim ownership
            of your content and the use of iWarranty is not intended
            to change your rights in your content. We do not claim
            ownership of your content that you post on or through the
            Service. Instead, when you share, post, or upload content
            that is covered by intellectual property rights (like
            photos or videos) on or in connection with our Service,
            you hereby grant to us a non-exclusive, royalty-free,
            transferable, sub-licensable, worldwide license to host,
            use, distribute, modify, run, copy, publicly perform or
            display, translate, and create derivative works of your
            content (consistent with your privacy and application
            settings). You can end this license anytime by deleting
            your content or account. However, the content will
            continue to appear if you shared it with others and they
            have not deleted it. To learn more about how we use
            information, and how to control or delete your content,
            review the Data Policy.
          </span>
          <span>
            <p />
          </span>
        </li>
        <li>
          <span>
            Permission to use your email, profile picture, and
            information about your relationships and actions with
            accounts you communicate with and where you select, ads,
            and sponsored content without any compensation from us to
            you. For example, were you instructed us to show you
            meaningful ads, we may show that you liked a sponsored
            post created by a brand that has paid us to display its
            ads that relate to your choices. As with actions on other
            content and follows of other accounts, actions on
            sponsored content and follows of sponsored accounts can be
            seen only by people who have permission to see that
            content or follow. We respect your ad settings which can
            learn more about being contacting iWarranty.
          </span>
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          <span>
            You agree that we can download and install updates to the
            iWarranty Service on your device
          </span>
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          <span>
            If you select a email or similar identifier for your
            account, we may change it if we believe it is appropriate
            or necessary (for example, if it infringes on someone’s
            intellectual property or impersonates or is too similar to
            another user).
          </span>
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Intellectual Property</strong>
      </p>
      <p>
        <span>
          If you use content covered by intellectual property rights
          that we own or have licensed and make available (for
          example, images, text, designs, videos, or sounds we provide
          that you add to the content you create or share), we or our
          third-party licensors retain all rights to ours and their
          content (but not yours).
        </span>
        <span>
          <br />
        </span>
        <span>
          <br />
        </span>
        <span>
          You can only use our or our third parties’ intellectual
          property and trademarks or similar marks as expressly
          permitted by our or their brand guidelines or with our or
          their prior written permission. You must obtain written
          permission from us or under an applicable open source
          license to modify, create derivative works of, decompile, or
          otherwise attempt to extract source code from us.
        </span>
      </p>
      <p />
      <p>
        <span>
          <br />
        </span>
        <strong>Our mutual agreement</strong>
      </p>
      <p>
        <span>
          Your use of iWarranty is subject to these Terms and our
          Privacy Policy. If you use certain other features or related
          services that we introduce over time, you will be provided
          with an opportunity to agree to additional terms that will
          also become a part of our agreement and these Terms. For
          example, if you use payment features, you will be asked to
          agree to the Payment Terms. If any of those terms conflict
          with this agreement, those other terms will govern.&nbsp;
        </span>
      </p>
      <p>
        <span>
          If any aspect of or particular provision within these Terms
          is unenforceable, the rest will remain in effect.
        </span>
        <span>
          <br />
        </span>
        <span>
          <br />
        </span>
        <span>
          Any amendment or waiver to these Terms must be in writing
          and signed by us. If we fail to enforce any aspect of this
          agreement, it will not be a waiver.
        </span>
        <span>
          <br />
        </span>
        <span>
          <br />
        </span>
        <span>
          We reserve all rights not expressly granted to you.
        </span>
        <span>
          <br />
        </span>
        <span>
          <br />
        </span>
        <strong>Other parties</strong>
      </p>
      <p>
        <span>
          This agreement does not give rights to any third parties.
          You cannot transfer your rights or obligations under this
          agreement without our consent. Our rights and obligations
          can be assigned to others. For example, this could occur if
          our ownership changes (as in a merger, acquisition, or sale
          of assets) or by law.
        </span>
        <span>
          <br />
        </span>
        <span>
          <br />
        </span>
        <strong>What happens if something occurs</strong>
      </p>
      <p>
        <span>
          We will use reasonable skill and care in providing the
          iWarranty Service to you and in keeping a safe, secure, and
          error-free environment, but we cannot guarantee or make
          assurances that this will always function without
          disruptions, delays, imperfections or other issues. Provided
          we have acted with reasonable skill and care, we do not
          accept responsibility for: losses not caused by our breach
          of these Terms or otherwise by our acts; losses which are
          not reasonably foreseeable by you and us at the time of
          entering into these Terms; any offensive, inappropriate,
          obscene, unlawful, or otherwise objectionable content posted
          by others that you may encounter on our Service; and events
          beyond our reasonable control. Subject to the following
          provision. These terms and the above do not exclude or limit
          our liability for death, personal injury, or fraudulent
          misrepresentation caused by our negligence. It also does not
          exclude or limit our liability for any other things where
          the law does not permit us to do so. Subject to this,
          however, our liability for any losses arising out of our
          performance of these Terms shall be limited to the extent
          permitted by law.
        </span>
        <span>
          <br />
        </span>
        <span>
          <br />
        </span>
        <strong>Disputes.</strong>
      </p>
      <p>
        <span>
          If you are a consumer and habitually reside in a Member
          State of the European Union, the laws of that Member State
          will apply to any claim, cause of action, or dispute you
          have against us that arises out of or relates to these Terms
          (“claim”), and you may resolve your claim in any competent
          court in that Member State that has jurisdiction over the
          claim. In all other cases, you agree that the claim must be
          resolved in a competent court in the United Kingdom and that
          the laws of England and Wales will govern these Terms and
          any claim, without regard to conflict of law provisions.
        </span>
      </p>
      <p />
      <p>
        <strong>Feedback</strong>
      </p>
      <p>
        <span>
          We always appreciate feedback or other suggestions, but may
          use them without any restrictions or obligation to
          compensate you for them, and are under no obligation to keep
          them confidential.
        </span>
      </p>
      <p />
      <p>
        <span>Updating These Terms</span>
      </p>
      <p>
        <span>
          <br />
        </span>
        <span>
          We may change our iWarranty Service and policies, and we may
          need to make changes to these Terms so that they accurately
          reflect our Service and policies. Unless otherwise required
          by law, we will notify you (for example, through our
          Service) at least 30 days before we make changes to these
          Terms and give you an opportunity to review them before they
          go into effect. Then, if you continue to use the Service,
          you will be bound by the updated Terms. If you do not want
          to agree to these or any updated Terms, you can delete your
          account, here.
        </span>
      </p>
      <p>
        <span>Version: 15 December 2019.</span>
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>We care about your personal data</strong>
      </p>
      <p>
        <span>
          We appreciate your interest in our products and services and
          your visit to this website. Your privacy is important to us
          and we want you to feel comfortable with how we use and
          share your personal information.
        </span>
      </p>
      <p>&nbsp;</p>
      <ul>
        <li>
          <h4>
            <strong>Who is the data controller?</strong>
          </h4>
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <span>
          A data controller is the individual or legal person who
          controls the use of the data and is responsible for keeping
          it safe. The laws apply to personal data in both paper and
          electronic files. iWarranty Ltd will be a data controller as
          defined by relevant data protection laws and regulations.
        </span>
      </p>
      <p>
        <span>
          Protecting your privacy is a top priority for us. This
          notice explains how and what type of personal data will be
          collected, why it is collected and with whom it is shared.
          Please read this notice carefully.
        </span>
      </p>
      <h4>
        <strong>
          2. What personal data will be collected?&nbsp;
        </strong>
      </h4>
      <p>
        <span>
          Depending on the type of product or service we provide to
          you, we will collect and process various types of personal
          data about you:
        </span>
      </p>
      <ul>
        <li>
          <span>surname, first name</span>
        </li>
        <li>
          <span>address</span>
        </li>
        <li>
          <span>place of residence</span>
        </li>
        <li>
          <span>date of birth</span>
        </li>
        <li>
          <span>gender</span>
        </li>
        <li>
          <span>telephone numbers</span>
        </li>
        <li>
          <span>email address</span>
        </li>
        <li>
          <span>credit/debit card and bank account details</span>
        </li>
        <li>
          <span>purchase receipt/product images&nbsp;</span>
        </li>
      </ul>
      <p>
        <span>
          some of which may be required for fraud detection purposes.
        </span>
      </p>
      <p>
        <strong>A</strong>
        <strong>
          &nbsp;&nbsp;&nbsp;<span>&nbsp;</span>
        </strong>
        <strong>Warranty Assistance&nbsp;</strong>
      </p>
      <p>
        <span>
          In the event of your use of our app, we will collect and
          process data relating to that use to enable us to provide
          our service to you.&nbsp;
        </span>
      </p>
      <p>
        <strong>B</strong>
        <strong>
          &nbsp;&nbsp;&nbsp;<span>&nbsp;</span>
        </strong>
        <strong>Travel and Homecare&nbsp;</strong>
      </p>
      <p>
        <span>
          We may also collect and process special category data about
          you, such as medical information, where you have purchased a
          travel or homecare product.
        </span>
      </p>
      <h4>
        <strong>
          3. How will we obtain and use your personal data?
        </strong>
      </h4>
      <p>
        <span>
          We will collect and use the personal data that you provide
          to us and that we receive about you (as explained below) for
          a number of purposes. We provide more information in the
          following table:
        </span>
      </p>
      <p>&nbsp;</p>
      <table>
        <tbody>
          <tr>
            <td>
              <p>
                <strong>Purpose</strong>
              </p>
            </td>
            <td>
              <p>
                <strong>Do we need your express consent?</strong>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <strong>
                  the administration of products and services (for
                  example, sending details of cover, handling claims,
                  providing warranty terms, quotes, underwriting)
                </strong>
              </p>
            </td>
            <td>
              <p>
                <span>no</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <strong>fraud prevention and detection</strong>
              </p>
            </td>
            <td>
              <p>
                <span>no</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <strong>
                  to meet any legal obligations (for example,
                  regulatory, tax, accounting and administrative
                  obligations)
                </strong>
              </p>
            </td>
            <td>
              <p>
                <span>no</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <strong>
                  to redistribute risk by means of reinsurance and
                  co-insurance
                </strong>
              </p>
            </td>
            <td>
              <p>
                <span>no</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <strong>
                  to enhance, modify, personalise or otherwise improve
                  our services/ communications for the benefit of our
                  customers
                </strong>
              </p>
            </td>
            <td>
              <p>
                <span>no</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <strong>
                  to enhance the security of our networks and
                  information systems
                </strong>
              </p>
            </td>
            <td>
              <p>
                <span>no</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <strong>
                  to better understand how people interact with our
                  websites
                </strong>
              </p>
            </td>
            <td>
              <p>
                <span>no</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <strong>
                  to determine the effectiveness of promotional
                  campaigns and advertising
                </strong>
              </p>
            </td>
            <td>
              <p>
                <span>no</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <span>
          From time to time we may wish to inform you, or permit
          selected third parties to inform you about products and
          services that we feel may be of interest to you in
          accordance with your marketing preferences. However, we can
          only do this with your express, written consent. You can
          change your mind about this at any time by contacting us as
          set out in section 10 below.
        </span>
      </p>
      <p>
        <span>
          We will process personal data we receive about you from
          third parties such as brokers and business partners, other
          insurers and fraud prevention agencies.
        </span>
      </p>
      <p>
        <span>
          We will process your personal data where it is necessary for
          us to comply with our contractual obligations to you, or
          where we need to take pre-contractual steps at your request.
        </span>
      </p>
      <p>
        <span>
          We will process your personal data where necessary for the
          purposes of our legitimate interests. “Legitimate interests”
          means the interests of our company in conducting and
          managing our business to enable us to give you the best
          service/products and the best and most secure experience.
          When we process your personal information for our legitimate
          interests, we make sure that we consider and balance any
          potential impact on you and your rights under the data
          protection laws. Our legitimate business interests do not
          automatically override your interests –we will not use your
          personal data where our interests are overridden by the
          impact on you (unless we are required or permitted by law).
        </span>
      </p>
      <p>
        <span>
          Special category data is personal data which is regarded as
          more sensitive and so needs greater protection and so will
          only use your personal data for the purposes described above
          if you agree with that and would like to buy our products
          and services. If you do not wish to provide this to us, we
          may not be able to provide the products and services to you.
        </span>
      </p>
      <h4>
        <strong>
          4. Who will have access to your personal data?
        </strong>
      </h4>
      <p>
        <span>
          We will ensure that your personal data is processed in a
          manner that is compatible with the purposes indicated above.
        </span>
      </p>
      <p>
        <span>
          For the reasons stated above, your personal data may be
          disclosed to the following parties who operate as third
          party data controllers such as:
        </span>
      </p>
      <ul>
        <li>
          <span>
            Insurers, retailers and manufactures, technical
            consultants, lawyers and loss adjustors, third party
            repairers in respect of your appliance products; service
            companies to discharge operations (claims, IT, postal,
            document management; and
          </span>
        </li>
        <li>
          <span>
            advertisers and advertising networks to send you marketing
            communications, as permitted under local law and in
            accordance with your communication preferences). We do not
            share your personal data with non-affiliated third parties
            for marketing purposes without your permission.
          </span>
        </li>
        <li>
          <span>
            Finally, we may share your personal data in the following
            instances:
          </span>
        </li>
        <li>
          <span>
            in the event of any contemplated or actual reorganization,
            merger, sale, joint venture, assignment, transfer or other
            disposition of all or any portion of our business, assets
            or stock (including in any insolvency or similar
            proceedings); and
          </span>
        </li>
        <li>
          <span>
            to meet any legal obligation, including to the Financial
            Ombudsman Services if you make a complaint about the
            product or service we have provided to you.
          </span>
        </li>
      </ul>
      <h4>
        <strong>5. Where will my personal data be processed?</strong>
      </h4>
      <p>
        <span>
          Your personal data may be processed both inside and outside
          of the European Economic Area (EEA) by the parties specified
          in section 4 above, subject always to contractual
          restrictions regarding confidentiality and security in line
          with applicable data protection laws and regulations. We
          will not disclose your personal data to parties who are not
          authorised to receive it.
        </span>
      </p>
      <p>
        <span>
          Whenever we transfer your personal data for processing
          outside of the EEA, we will take steps to ensure that the
          transfer of your personal data outside of the EEA receives
          the same level of protection as it does in the EEA.&nbsp;
        </span>
      </p>
      <ol start={6}>
        <li>
          <strong>
            What are your rights in respect of your personal data?
          </strong>
        </li>
      </ol>
      <p>
        <span>
          Where permitted by applicable law or regulation, you have
          the right to:
        </span>
      </p>
      <ul>
        <li>
          <span>
            access the personal data held about you and to learn the
            origin of the data, the purposes and ends of the
            processing, the details of the data controller(s), the
            data processor(s) and the parties to whom the data may be
            disclosed;
          </span>
        </li>
        <li>
          <span>
            withdraw your consent at any time where your personal data
            is processed with your consent;
          </span>
        </li>
        <li>
          <span>
            update or correct your personal data so that it is always
            accurate;
          </span>
        </li>
        <li>
          <span>
            delete your personal data from our records if it is no
            longer needed for the purposes indicated above;
          </span>
        </li>
        <li>
          <span>
            restrict the processing of your personal data in certain
            circumstances, for example where you have contested the
            accuracy of your personal data, for the period enabling us
            to verify its accuracy;
          </span>
        </li>
        <li>
          <span>
            obtain your personal data in an electronic format for you
            or for your new insurer; and
          </span>
        </li>
        <li>
          <span>
            file a complaint with us and/or the Information
            Commissioner’s Office.
          </span>
        </li>
      </ul>
      <p>
        <span>
          You may exercise these rights by contacting us as detailed
          in section 10 below.
        </span>
      </p>
      <h4>
        <strong>
          7. How can you object to the processing of your personal
          data?
        </strong>
      </h4>
      <p>
        <span>
          You have the right to object to us processing your personal
          data, or tell us to stop processing it (including for
          purposes of direct marketing). Once you have informed us of
          this request, we shall no longer process your personal data
          unless permitted by applicable laws and regulations.
        </span>
      </p>
      <p>
        <span>
          You may exercise this right in the same manner as for your
          other rights indicated in section 6 above.
        </span>
      </p>
      <h4>
        <strong>8. How long do we keep your personal data?</strong>
      </h4>
      <p>
        <span>
          We will retain your personal data for a maximum of seven
          years from the date the date you have notified us or we
          otherwise become aware that you have ceased using our app.
          If we are able to do so we will delete or anonymise certain
          areas of your personal data as soon as that information is
          no longer required for the purposes for which it was
          obtained.
        </span>
      </p>
      <h4>
        <strong>
          9. Automated decision making, including profiling
        </strong>
      </h4>
      <p>
        <span>
          We may use automated decision making, including profiling,
          to assess how we may best provide our products or services
          to you, including insurance, insurance risks, detection of
          fraud, and to administer your claims. This helps us to
          decide whether to offer the insurance and determine prices.
        </span>
      </p>
      <p>
        <span>
          If you have any concerns regarding the decision reached,
          please let us know at the contact details set out in section
          10 below and we will arrange for a person to check the
          accuracy of the result.
        </span>
      </p>
      <h4>
        <strong>10. How can you contact us?</strong>
      </h4>
      <p>
        <span>
          If you have any queries about how we use your personal data,
          you can contact us as follows:
        </span>
      </p>
      <p>
        <span>
          By post: Data Protection Officer, iWarranty Limited, 19-21
          Crawford Street, Marylebone W1H1PN
        </span>
      </p>
      <p>
        <span>By email: rpillai@iWarranty.co</span>
      </p>
      <p>
        <span>
          We will need details of your name, email address, policy
          number, and purpose of your request.
        </span>
      </p>
      <h4>
        <strong>
          11. How often do we update this privacy notice?
        </strong>
      </h4>
      <p>
        <span>
          We regularly review this privacy notice. This privacy notice
          was last updated in December 2019.
        </span>
      </p>
    </TermsOfUseContainer>
  );
}
